import React, { Component } from 'react';
import { saveAs } from 'file-saver';
import downloadService from '../../../../../services/downloadService';
import Table from '../../../../../components/Table/table.component';
import { DACA_PERMISSIONS } from 'constants/index';

export default class VisualizaHistoricoDacaSaidaOutros extends Component {
	constructor(props) {
		super(props);
		this.state = {
			documentos: [],
		};
		this.columns = [];
		this.actions = [];
	}

	componentWillMount() {
		this.columns = [
			{ id: 0, title: 'Termo de recebimento', property: 'nome' },
		];

		this.actions = [
			{
				id: 0,
				name: 'Download do arquivo',
				icon: 'fas fa-download',
				action: item => this.downloadFile(item),
			},
		];
		const { transacao } = this.props;
		this.setState({ documentos: [transacao.documento] });
	}

	downloadFile = async (documento) => {
		const { data: arquivo } = await downloadService.download(documento);
		const blob = new Blob([arquivo]);
		saveAs(blob, documento.nome);
	};

	render() {
		const {
			props: {
				transacao,
				isDacaPermanente,
			},
			state: {
				documentos,
			},
		} = this;

		return (
			<div className='col-12 d-flex flex-column pl-0 pr-0'>

				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Item:</strong>
						<p>{transacao.daca.nome}</p>
					</div>
					<div className='col-6'>
						<strong>Tipo de transação: </strong>
						<p>Saída</p>
					</div>
				</div>

				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Tipo de retirada: </strong>
						{!isDacaPermanente && (
							<p>Outros</p>
						)}
						{isDacaPermanente && transacao.emprestimo && (
							<p>Empréstimo - Outros</p>
						)}
						{isDacaPermanente && !transacao.emprestimo && (
							<p>Descarte</p>
						)}
					</div>
					<div className='col-6'>
						<strong>Tipo de estoque: </strong>
						<p>{transacao.origem}</p>
					</div>
				</div>

				{!transacao.emprestimo && (
					<div className='d-flex col-12 pl-0 pr-0'>
						<div className='col-6'>
							<strong>Quantidade: </strong>
							<p>{transacao.quantidadeEntradaSaida}</p>
						</div>
						<div className='col-6'>
							<strong>Data de saída: </strong>
							<p>{transacao.dataCadastro}</p>
						</div>
					</div>
				)}

				{transacao.emprestimo && isDacaPermanente && (
					<div className='d-flex col-12 pl-0 pr-0'>
						<div className='col-12'>
							<strong>Destino: </strong>
							<p>{transacao.destinoEmprestimo}</p>
						</div>
					</div>
				)}

				<div className='col-12 text-justify'>
					<strong>Motivo: </strong>
					<p>{transacao.motivo}</p>
				</div>

				{(transacao.emprestimo || !isDacaPermanente) && (
					<div>
						<Table
							isPageNumber={false}
							acoesSingleButton
							className='text-left'
							columns={this.columns}
							actions={this.actions}
							data={documentos}
							emptyMessage='Não há registros cadastrados.'
							emptyColSpan={this.columns.length + 1}
							showPaginate={false}
							maxCharactersShown={75}
							permission={DACA_PERMISSIONS.VISUALIZAR}
						/>
					</div>
				)}
			</div>
		);
	}
}
